import React, { useState, useEffect, useCallback } from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import axios from 'axios';
import jsPDF from "jspdf";
import ExcelJS from 'exceljs';
import "jspdf-autotable";
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate } from 'react-router-dom';
import pds from './pds.PNG';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import {
    Chart as ChartJS, // Use ChartJS instead of Chart
    ArcElement,
    Tooltip,
    Legend,
    Title,
    CategoryScale,
    LinearScale,
    BarElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';  // Import the datalabels plugin
import './AllDistrictsAndSubdivisions.css';

// Register the required chart elements
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title,
    CategoryScale,
    LinearScale,
    BarElement,
    ChartDataLabels  // Register the datalabels plugin to display text inside the chart
);

// Home component
const AllDistrictsAndSubdivisions = () => {
    const navigate = useNavigate();
    const [activeButton, setActiveButton] = useState('fps');
    const [currentLevel, setCurrentLevel] = useState("district"); // Can be "district", "subdivision", "block"
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedDistrictName, setSelectedDistrictName] = useState(null);
    const [selectedSubDivision, setSelectedSubDivision] = useState(null);
    const [selectedBlock, setSelectedBlock] = useState(null);
    const [selectedPanchayat, setSelectedPanchayat] = useState(null);
    const [data, setData] = useState([]);
    const [totalShops, setTotalShops] = useState([]);


    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showEndCalendar, setShowEndCalendar] = useState(false);
    // Static values for shops
    const [inspectedShops, setInspectedShops] = useState(0); // Static value for inspected shops
    const [pendingShops, setPendingShops] = useState(0);    // Static value for pending shops

    // Calculate percentages
    const inspectedPercentage = ((inspectedShops / totalShops) * 100).toFixed(2);
    const pendingPercentage = ((pendingShops / totalShops) * 100).toFixed(2);

    const [totalInspections, setTotalInspections] = useState(0);  // Changed initial state to null


    // Default to today's date
    const [subDivisions, setSubDivisions] = useState([]);  // Initialize as an empty array
    const [blocks, setBlocks] = useState([]);  // Initialize as an empty array
    const [selectedDate, setSelectedDate] = useState(""); // State for selected date
    const [panchayats, setPanchayats] = useState('');
    useEffect(() => {
        // Set selectedDate to the first day of the current month when the component mounts
        const date = new Date();
        const currentMonthFirstDay = new Date(date.getFullYear(), date.getMonth(), 2).toISOString().slice(0, 10);
        setSelectedDate(currentMonthFirstDay);
    }, []); // Empty dependency array ensures this runs only once when the component mounts

    const handleEndDateIconClick = () => {
        // Only show the calendar for endDate if startDate is selected
        if (startDate) {
            setShowEndCalendar(true);
        }
    };

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0); // Reset time to midnight
    // Determine the minimum date for the endDate date picker
    const currentYear = currentDate.getFullYear();
    const minStartDate = new Date(currentYear, 0, 1); // January 1st of current year

    const [apiData, setApiData] = useState(null); // Hold the fetched data



   

    // Initial useEffect to set fromDate to the first day of the current month
    useEffect(() => {
        const today = new Date();
        const fromDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1)); // UTC set to first day of current month
       // fetchData(fromDate.toISOString().slice(0, 10), period); // Initial data fetch with "Current Month"
    }, []);



    // Data for Pie Chart
    const pieData = {
        labels: [
            ` (${pendingPercentage}%)`,
            ` (${inspectedPercentage}%)`
        ],
        datasets: [
            {
                data: [pendingShops, inspectedShops], // Data for the pie chart totalInspections
                backgroundColor: ['#d21300', '#2a6d8b'], // Reversed background colors
                hoverBackgroundColor: ['#d21300', '#2a6d8b'], // Reversed hover colors
            },
        ],
    };

    const pieOptions = {
        responsive: true,  // Ensure it’s responsive to different screen sizes
        plugins: {
            tooltip: {
                enabled: false,  // Disable the tooltip completely
            },
            datalabels: {
                display: true,  // Always display the data labels
                color: '#fff',  // Color of the text inside the Pie chart
                formatter: (value, context) => {
                    // If you want to display the number of inspected shops inside the Pie chart
                    if (context.datasetIndex === 1) {
                        return inspectedShops.toLocaleString();  // Show the number of inspected shops inside the Pie chart
                    } else {
                        return value.toLocaleString();  // For pending shops, show the corresponding number
                    }
                },
                font: {
                    size: 12,
                },
                align: 'center',  // Center the text inside the pie chart
                anchor: 'center',  // Anchor the text to the center of the pie
            },
        },
        rotation: Math.PI,  // Rotates the chart by 180 degrees (π radians)
    };

    const [currentDateTime, setCurrentDateTime] = useState({
        date: '',
        time: '',
    });
    const token = `${process.env.REACT_APP_BEFORE_TOKEN}`;
    const baseUrl = `${process.env.REACT_APP_API_BASE_URL}/reports/home-page`;  // Define the base URL
    const getHomePageBarsData = useCallback((from, to) => {
        if (token) {
            axios.post(baseUrl, { from, to }, { headers: { Authorization: `Bearer ${token}` } })
                .then((response) => {
                    if (response.data) {
                        setApiData(response.data);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching API:", error);
                });
        }
    }, [token]); // Remove debounce to test

    useEffect(() => {
        const now = new Date();
        const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 2);
        const formattedFromDate = firstDayOfMonth.toISOString().slice(0, 10); // e.g., "2025-04-01"
        const formattedToDate = now.toISOString().slice(0, 10); // e.g., "2025-04-04"
        const showStartdate = new Date(now.getFullYear(), now.getMonth(), 1)
        const shoeendDate = now;
        setStartDate(showStartdate);
        setEndDate(shoeendDate);
        // Fetch data for the current month on page load
        getDistrictWiseData(formattedFromDate, formattedToDate);
        localStorage.setItem('formattedFromDateForQtl', formattedFromDate);
        localStorage.setItem('formateedToDateForQtl', formattedToDate)
        // console.log("formared set date formmattedFromDate ",formattedFromDate)
        // console.log("formared set date formmattedFromDate",formattedToDate)
        getHomePageBarsData(formattedFromDate, formattedToDate);
    }, []);


    const getDistrictWiseData = (fromDate, toDate) => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/subdivision-data-All-Districts/from/${fromDate}/to/${toDate}`)
            .then((response) => {
                setData(response.data.sort((a, b) => a.districtName.localeCompare(b.districtName)));

                const totals = response.data.reduce(
                    (acc, item) => {
                        acc.totalShops += item.totalShops;
                        acc.inspectedShops += item.inspectedShops;
                        acc.totalInspections += item.totalInspections;
                        acc.pendingShops += item.pendingShops;
                        return acc;
                    },
                    { totalShops: 0, inspectedShops: 0, pendingShops: 0, totalInspections: 0 }
                );

                setInspectedShops(totals.inspectedShops);
                setPendingShops(totals.pendingShops);
                setTotalShops(totals.totalShops);
                setTotalInspections(totals.totalInspections);
            })
            .catch((error) => {
                console.error("Error fetching district-wise data", error);
            });
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
        setShowCalendar(false); // Hide the calendar after date selection
        setEndDate('');
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
        setShowEndCalendar(false); // Hide the calendar after date selection

        if (startDate && date) {
            // Call APIs only if both dates are selected
            const formattedFromDate = format(startDate, 'yyyy-MM-dd');
            const formattedToDate = format(date, 'yyyy-MM-dd');
            localStorage.setItem('formattedFromDateForQtl', formattedFromDate);
            localStorage.setItem('formateedToDateForQtl', formattedToDate)
            //console.log("formared set date formmattedFromDate ", formattedFromDate)
            //console.log("formared set date formmattedFromDate", formattedToDate)
            getHomePageBarsData(formattedFromDate, formattedToDate);
            getDistrictWiseData(formattedFromDate, formattedToDate);
        }
    };


    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/today-count`)
            .then((response) => {
                setTotalInspections(response.data); // Set the total inspections count from backend
            })
            .catch((error) => {
                console.error("There was an error fetching today's count!", error);
            });

        let date = new Date();
        date.setDate(1);  // Set to the first day of the current month

        // Update the current date and time every minute
        const updateDateTime = () => {
            const now = new Date();
            const day = now.getDate().toString().padStart(2, '0'); // Adds leading zero if needed
            const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
            const year = now.getFullYear().toString().slice(); // Get the last two digits of the year

            const formattedDate = `${day}-${month}-${year}`;
            let formattedTime = now.toLocaleTimeString('en-GB', {
                hour12: true,
                hour: '2-digit',
                minute: '2-digit',
            });
            formattedTime = formattedTime.replace(/\s(am|pm)/, (match) => match.toUpperCase());

            setCurrentDateTime({
                date: formattedDate,
                time: formattedTime,
            });
        };
        updateDateTime();
        const interval = setInterval(updateDateTime, 60000); // Update every minute
        return () => clearInterval(interval); // Cleanup on component unmount
    }, []);





    const downloadPDF = () => {
        const doc = new jsPDF();

        doc.addImage(pds, 'jpeg', 9.5, 10, 190, 30); // Image format: 'JPEG'

        let yPosition = 45; // Starting Y position
        let tableData = []; // This will hold the data for the table
        let title = ''; // This will hold the title for the PDF
        let totalShops = 0, totalInspections = 0, inspectedShops = 0, pendingShops = 0; // Variables to accumulate totals

        // Set the font to bold for title
        doc.setFont("helvetica", "bold");
        const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
        const formattedToDate = localStorage.getItem('formateedToDateForQtl');
        // Determine which level of data to include
        if (currentLevel === "district") {
            title = `SubDivision wise Inspection Summary For All Districts`;

            // Add title to the PDF
            doc.text(title, 14, yPosition);
            yPosition += 10; // Adjust the yPosition for the date range below the title

            // Format the date range text
            doc.text(`Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}  To Date : ${format(formattedToDate, "dd-MM-yyyy")}`, 14, yPosition);

            // Set font to normal for the date range and add it below the title
            doc.setFont("helvetica", "normal");
            yPosition += 10; // Move the position down for the table

            // Populate the tableData for district level
            tableData = filteredData.map((row, index) => {
                totalShops += row.totalShops;
                totalInspections += row.totalInspections;
                inspectedShops += row.inspectedShops;
                pendingShops += row.pendingShops;

                return [
                    index + 1,
                    capitalizeFirstLetter(row.districtName),
                    capitalizeFirstLetter(row.subdivisionName),
                    formatNumber(row.totalShops),
                    formatNumber(row.totalInspections),
                    formatNumber(row.inspectedShops),
                    formatNumber(row.pendingShops),
                    `${row.percentage}%`
                ];
            });
        } 
        yPosition += 5; // Ensure space between the title/date range and the table

        // Get the current date and time
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        // Set the date text color (black) and make it bold
        doc.setFont('helvetica', 'bold'); // Use Helvetica font and bold style
        doc.setTextColor(0, 0, 0);  // Black color for the date
        doc.setFontSize(12);

        // Add the current date and time to the PDF, positioned at the bottom-right corner
        doc.text(`Report Date: ${formattedDateTime}`, 195, yPosition, { align: 'right' });

        // Update yPosition to create space after the date
        yPosition += 5;
        // Table header based on the current level
        let header;
        if (currentLevel === "district") {
            header = [['S.No', 'District', 'Subdivision','Total No. of FP Shops', 'No.Of FPS Inspections', 'No. of FPS Shops Inspected', 'No. of FPS Shops Pending', '% of FPS Shops Inspected']];
        } 

        // Adding the table with dynamic header and data
        doc.autoTable({
            startY: yPosition, // Start the table below the title and date range
            head: header, // Dynamically set the header based on the current level
            body: [...tableData, [  // Append the total row to the table body
                '',  // Empty cell for serial number
                '',
                'Total',  // Total label
                formatNumber(totalShops),
                formatNumber(totalInspections),
                formatNumber(inspectedShops),
                formatNumber(pendingShops),
                ((inspectedShops / totalShops) * 100).toFixed(2) + '%'  // Percentage of shops inspected
            ]],
            headStyles: {
                fillColor: [255, 165, 0],
                textColor: [255, 255, 255],  // Text color: White
                fontSize: 10,
                halign: 'center',  // Center header text
            },
            styles: {
                fontSize: 9,
                halign: 'center',  // Align text in the middle by default
            },
            columnStyles: {
                1: { halign: 'left' }, // Column index 1 (Name) aligned to left
                2: { halign: 'right' }, // Total No. of FP Shops
                3: { halign: 'right' }, // No. of Shops Inspected
                4: { halign: 'right' }, // No. of Inspections
                5: { halign: 'right' }, // No. of Shops Pending
                6: { halign: 'right' }, // Percentage of Shops Inspected
                7: { halign: 'right' }, // Percentage of Shops Inspected
            },
            didParseCell: (data) => {
                // Apply background color and text color for the total row
                if (data.row.index === tableData.length) {  // The last row is the total row
                    data.cell.styles.fillColor = [12, 92, 108];  // Dark blue background
                    data.cell.styles.textColor = [255, 255, 255];  // White text
                    data.cell.styles.fontSize = 10;
                }
            },
        });

        // Save PDF with the dynamic title as filename
        doc.save(`${title.replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '')}.pdf`);
    };


    const downloadExcel = async () => {
        // 2. Generate Excel file using ExcelJS

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('SubDivision wise Inspection Summary For All Districts');


        worksheet.mergeCells('A1:H1'); // Merge cells for the title
        worksheet.getCell('A1').value = 'SubDivision wise Inspection Summary For All Districts';
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A1').font = { size: 16, bold: true, color: { argb: 'FF2A6D8B' } };  // Text color: Light Steel Blue (ARGB format)
        worksheet.getCell('A1').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };


        let tableData = [];
        let title = '';

        // Determine which level of data to include
        if (currentLevel === "district") {
            title = "SubDivision wise Inspection Summary For All Districts";  // Title for district
            tableData = filteredData.map((row, index) => [
                index + 1,  // S.No (column 1)
                capitalizeFirstLetter(row.districtName),  // District Name (column 2)
                capitalizeFirstLetter(row.subdivisionName),  // Subdivision Name (column 2)
                formatNumber(row.totalShops),  // Total Shops (column 3)
                formatNumber(row.totalInspections),  // Inspections (column 5)
                formatNumber(row.inspectedShops),  // Inspected Shops (column 4)
                formatNumber(row.pendingShops),  // Pending Shops (column 6)
                `${row.percentage}%`  // Percentage (column 7)
            ]);
        } 

        // Add title to the Excel file
        worksheet.getCell('A1').value = title;
        worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };


        worksheet.mergeCells('A2:H2'); // Merge cells for the title

        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'center' };
        worksheet.getCell('A2').font = { size: 11, bold: true, color: { argb: '000000' } };  // Text color: Light Steel Blue (ARGB format)
        worksheet.getCell('A2').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        const currentDate = new Date();

        // Format the date as DD-MM-YYYY
        const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Format the time as HH:mm:ss
        const formattedTime = `${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;

        // Combine both date and time into one string
        const formattedDateTime = `${formattedDate} ${formattedTime}`;
        worksheet.getCell('A2').value = `Report Date : ${formattedDateTime}`;
        worksheet.getCell('A2').alignment = { vertical: 'middle', horizontal: 'right' };

        const formattedFromDate = localStorage.getItem('formattedFromDateForQtl');
        const formattedToDate = localStorage.getItem('formateedToDateForQtl');
        worksheet.getCell('A3').value = `Form Date : ${format(formattedFromDate, 'dd-MM-yyyy')}     To Date : ${format(formattedToDate, "dd-MM-yyyy")}`;
        worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'left' };

        worksheet.mergeCells('A3:H3'); // Merge cells for the title

        worksheet.getCell('A3').font = { size: 11, bold: true, color: { argb: '000000' } };  // Text color: Light Steel Blue (ARGB format)
        worksheet.getCell('A3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'F5F5F5' }  // Background color: Whitesmoke (ARGB format)
        };
        let headerRow;

        if (currentLevel === "district") {
            headerRow = ['S.No', 'District','Subdivision', 'Total No. of FP Shops', 'No.Of FPS Inspections', 'No. of FPS Shops Inspected', 'No. of FPS Shops Pending', '% of FPS Shops Inspected'];
        } 
        // Add dynamic header row
        worksheet.addRow(headerRow);

        // Apply header style: bold, size 12, and orange background
        worksheet.getRow(4).font = { bold: true, size: 12 };
        worksheet.getRow(4).alignment = { horizontal: 'center' }; // Center alignment

        // Apply background color to the first 6 cells of the header row
        for (let col = 1; col <= 8; col++) {
            const cell = worksheet.getCell(4, col); // Get each cell in the first row (header)
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFFA500' }  // Orange background color
            };
            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };
            // Add border to header cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };
        }

        // Adjust column widths
        worksheet.columns = [
            { key: 'A', width: 10 },  // Column A width
            { key: 'B', width: 20 },  // Column B width
            { key: 'C', width: 25 },  // Column C width
            { key: 'D', width: 25 },  // Column D width
            { key: 'E', width: 30 },  // Column E width
            { key: 'F', width: 30 },  // Column F width
            { key: 'G', width: 30 },  // Column G width
            { key: 'H', width: 30 },  // Column G width
        ];

        // Add data rows
        tableData.forEach((row, index) => {
            const dataRow = worksheet.addRow([
                index + 1,  // S.No (column 1)
                row[1],  // District Name / Subdivision Name / Block Name (column 2)
                row[2],  // Subdivision Name (column 2)
                row[3],  // Total Shops (column 3)
                row[4],  // Inspections (column 5)
                row[5],  // Inspected Shops (column 4)
                row[6],  // Pending Shops (column 6)
                row[7]   // Percentage (column 7)
            ]);

            // Apply cell alignment
            dataRow.eachCell((cell, colNumber) => {
                if (colNumber === 1) {  // S.No (column 1)
                    cell.alignment = { horizontal: 'center' };  // Center align for S.No
                } else if (colNumber === 2) {  // Name (column 2)
                    cell.alignment = { horizontal: 'left' };  // Left align for Name
                } else {  // All other columns (3 to 7)
                    cell.alignment = { horizontal: 'right' };  // Right align for the other columns
                }
            });
        });

        // Add total row
        worksheet.addRow([
            '',
            '',
            'Total',
            formatNumber(totalShops),
            formatNumber(totalInspections),
            formatNumber(inspectedShops),

            formatNumber(pendingShops),
            ((inspectedShops / totalShops) * 100).toFixed(2) + '%'
        ]);

        // Apply total row style: bold, size 12, orange background
        const totalRow = worksheet.lastRow;

        // Apply the styling to the first 6 cells in the total row
        for (let col = 1; col <= 8; col++) {
            const cell = totalRow.getCell(col); // Get each cell in the total row

            // Apply background color (orange) to the total row cells
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF2A6D8B' }  // Orange background color
            };

            // Apply font styling: bold and size 12
            cell.font = { bold: true, size: 12, color: { argb: 'FFFFFFFF' } };

            // Apply border styling for total row cells
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };

            // Apply center alignment to all cells except the "Total" text
            if (col === 2) {  // "Total" text in column 2
                cell.alignment = { horizontal: 'left' };  // Left align "Total"
            } else {
                cell.alignment = { horizontal: 'right' };  // Right align the rest of the cells
            }
        }

        const fileName = title.replace(/ /g, '_').replace(/[^a-zA-Z0-9_]/g, '') + '.xlsx';

        // Save the file (Excel)
        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], { type: 'application/octet-stream' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        });
    };




    // Get filtered data based on the current level
    const filteredData =
        currentLevel === "district" ? data :
            currentLevel === "subdivision" ? subDivisions : currentLevel === "block" ? blocks : panchayats[selectedBlock] || []
    // blocks[selectedSubDivision] || [];
    // Use staticBlocks as per your existing logic

    const capitalizeFirstLetter = (text) => {
        // Check if the text is defined and not empty
        if (text && typeof text === 'string') {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        return ''; // Return an empty string if text is undefined or not a string
    };

    //console.log("Filtered Data:", filteredData);


    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-IN').format(number); // 'en-IN' for Indian number formatting (commas at appropriate positions)
    };



    return (
        <div className="sizes-widths">
              <div>

              </div>
             
            <div className="subDivisionsAllDistricts-boxes-bars">
                 <div className="conenteofPara-1">SubDivision wise Inspection Summary For All Districts</div>
                <div className="ip-pi-flexclass">
                    {/* Pie Chart Section */}
                    <div className="chart-container">
                        <div className="input-container">
                            <div className='calMainCal'>
                                <div className="homeCal-Date">
                                    <label htmlFor="startDate" className="district-items-testing-stock-repo"><span className="asterisk">*</span>From</label>
                                    <div className="homeHCal">
                                        <input
                                            type="text"
                                            id="startDate"
                                            className="HHome-input-repo"
                                            value={startDate ? format(startDate, 'dd-MM-yyyy') : ''}
                                            readOnly
                                            onClick={() => setShowCalendar(true)}
                                        />
                                        <div className="HHOME-icon-test-stock-repo" onClick={() => setShowCalendar(true)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                                <path d="M7 10l5 5 5-5z" />
                                            </svg>
                                        </div>
                                        {showCalendar && (
                                            <DatePicker
                                                selected={startDate}
                                                onChange={handleStartDateChange}
                                                onClickOutside={() => setShowCalendar(false)}
                                                popperPlacement="bottom-start"
                                                minDate={minStartDate} // From January 1st of current year
                                                maxDate={currentDate} // Today
                                                inline
                                            />
                                        )}
                                    </div>
                                </div>

                                <div className="homeCal-Date">
                                    <label htmlFor="startDate" className="district-items-testing-stock-repo"><span className="asterisk">*</span>To</label>
                                    <div className="homeHCal-1">
                                        <input
                                            type="text"
                                            id="endDate"  // Changed this from 'startDate' to 'endDate'
                                            className="HHome-input-repo"
                                            value={endDate ? format(endDate, 'dd-MM-yyyy') : ''}
                                            readOnly
                                            onClick={() => setShowEndCalendar(true)} // Ensure this toggles correctly
                                        />
                                        <div className="HHOME-icon-test-stock-repo" onClick={handleEndDateIconClick}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="orange">
                                                <path d="M7 10l5 5 5-5z" />
                                            </svg>
                                        </div>
                                        {showEndCalendar && (
                                            <DatePicker
                                                selected={endDate}

                                                onChange={handleEndDateChange}
                                                onClickOutside={() => setShowEndCalendar(false)}

                                                // minDate={minEndDate} // Disable dates before startDate
                                                minDate={startDate}
                                                maxDate={currentDate} // Today
                                                popperPlacement="top-start"
                                                inline
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Pie Chart */}
                  
                </div>
            </div>

            <div className="border-above-name">
                <div className="conenteofPara-1">FPS Inspection History</div>
                <div className="border-pi">


                    {/* Table Section */}
                    <div className="home-main">
                        <div className="button-container">
                            <button className="dowPdf" onClick={downloadPDF}>
                                Download Pdf
                            </button>
                            <button onClick={downloadExcel} className="dowPdf">
                                Download Xlsx
                            </button>
                        </div>

                        {/* District Table */}
                        {currentLevel === "district" && (
                            <table className="table-home">
                                <thead className="head-home">
                                    <tr className="tr-home-table">
                                        <th>S.No</th>
                                        <th>District</th>
                                        <th>SubDivision</th>
                                        <th>Total No. of FP Shops</th>
                                        <th>No.Of FPS Inspections</th>
                                        <th>No. of FPS Shops Inspected</th>
                                        <th>No. of FPS Shops Pending</th>
                                        <th>% of FPS Shops Inspected</th>
                                    </tr>
                                    <tr className="total-tr">
                                        <td colSpan="3" >
                                            <strong>Total</strong></td>
                                        <td>{formatNumber(totalShops)}</td>
                                        <td>{formatNumber(totalInspections)}</td>
                                        <td>{formatNumber(inspectedShops)}</td>

                                        <td>{formatNumber(pendingShops)}</td>
                                        <td>{totalShops !== 0 ? ((inspectedShops / totalShops) * 100).toFixed(2) + '%' : '0.00%'}</td>
                                    </tr>
                                </thead>
                                <tbody className="tbody-tr">
                                    {filteredData?.map((row, index) => (
                                        <tr
                                            key={index}
                                           // onClick={() => handleDistrictClick(row.districtName, row.districtId)}
                                        >
                                            <td>{index + 1}</td>
                                            <td>{capitalizeFirstLetter(row.districtName)}</td>
                                            <td>{capitalizeFirstLetter(row.subdivisionName)}</td>
                                            <td>{formatNumber(row.totalShops)}</td>
                                            <td>{formatNumber(row.totalInspections)}</td>
                                            <td>{formatNumber(row.inspectedShops)}</td>
                                            <td>{formatNumber(row.pendingShops)}</td>

                                            <td>{row.percentage}%</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
            {/* </div> */}
        </div>
    );
};

export default AllDistrictsAndSubdivisions;
